module.exports = __webpack_public_path__ + "static/todCostofService-148e6b737bcab1102d75faf018255e96.png";